/** Public illustrations for farmer vs consumer roles (see `frontend/public/`). */
export function publicAssetUrl(path) {
  const base = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

export const ROLE_IMG = {
  farmer: () => publicAssetUrl('/farmer.png'),
  consumerMale: () => publicAssetUrl('/male.png'),
  consumerFemale: () => publicAssetUrl('/female.png')
};
